import { render, staticRenderFns } from "./OutgoingDSP.vue?vue&type=template&id=25cd912a&"
import script from "./OutgoingDSP.vue?vue&type=script&lang=js&"
export * from "./OutgoingDSP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports